// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__3j6V6","info":"UpdateTermsInfo_info__BNnGq"};